import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditUserData } from "./adminComp/userEditModal";
import { useAlert } from "react-alert";
import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import "./AdminDashboard.css";

function DuplicateUsers({ adminType }) {
  const alert = useAlert();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(40);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [selectedData, setSelectedData] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getUsers = async () => {
    try {
      let payload = { page: page };
      setLoader(true);
      const userData = await api.getDuplicateUsers(payload);
      console.log(userData);
      setData(userData.user);
      setnoOfUser(userData.count);
      setLimit(userData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  const deleteUser = async (id) => {
    try {
      let payload = { id: id };
      setLoader(true);
      const userData = await api.deleteUser(payload);
      if (userData?.success) {
        alert.show("User Deleted");
        getUsers();
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const handleSearch = async () => {
    if (searchMail) {
      let payload = { email: searchMail };
      const res = await api.getUserByMail(payload);
      if (res?.success) {
        setData(res?.user);
      } else {
        alert.info("Invalid Email Address");
      }
    } else {
      alert.info("Please insert email for search");
    }
  };

  useEffect(() => {
    getUsers();
  }, [page, resetPage]);

  const handleReset = () => {
    setResetPage(!resetPage);
    setPage(1);
  };

  const makeSubscribeUser = async (email) => {
    const reason = window.prompt("Write a Reason");
    if (!reason || !reason.trim()) {
      alert.show("Reason is required");
      return;
    }

    try {
      let payload = { email: email, reason: reason.trim() };
      setLoader(true);
      const userData = await api.SuperAdminMakePaidUser(payload);
      console.log("User subscribed");
      if (userData?.success) {
        alert.success(userData?.msg);
        getUsers();
      } else {
        alert.error(userData?.msg || "something went wrong");
      }
      setLoader(false);
    } catch (error) {
      console.log(error?.message);
      setLoader(false);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <div className="duplicate-users-management-wrapper">
              {/* Header Section */}
              <div className="duplicate-users-header-section mb-5">
                <div className="duplicate-users-header-content">
                  <div className="duplicate-users-title-section">
                    <h1 className="duplicate-users-main-title">
                      <i className="fas fa-clone duplicate-users-title-icon me-3"></i>
                      Duplicate Users Management
                    </h1>
                    <p className="duplicate-users-subtitle">
                      Identify and manage duplicate user accounts in the system
                    </p>
                  </div>

                  {/* Search and Reset Section */}
                  <div className="duplicate-users-search-section">
                    <div className="duplicate-users-search-container">
                      <div className="duplicate-users-search-input-wrapper">
                        <i className="fas fa-search duplicate-users-search-icon"></i>
                        <input
                          type="text"
                          className="duplicate-users-search-input"
                          placeholder="Search duplicate users by email address..."
                          value={searchMail}
                          onChange={(e) => setSearchMail(e.target.value)}
                          onKeyPress={(e) =>
                            e.key === "Enter" && handleSearch()
                          }
                        />
                        {searchMail && (
                          <button
                            className="duplicate-users-search-clear"
                            onClick={() => setSearchMail("")}
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        )}
                      </div>
                      <button
                        className="duplicate-users-search-btn"
                        onClick={handleSearch}
                      >
                        <i className="fas fa-magnifying-glass me-2"></i>
                        Search
                      </button>
                    </div>
                    <button
                      className="duplicate-users-reset-btn"
                      onClick={handleReset}
                    >
                      <i className="fas fa-arrows-rotate me-2"></i>
                      Reset
                    </button>
                  </div>
                </div>

                {/* Stats Cards */}
                <div className="duplicate-users-stats-container">
                  <div className="duplicate-users-stat-card">
                    <div className="duplicate-users-stat-icon total-duplicates">
                      <i className="fas fa-clone"></i>
                    </div>
                    <div className="duplicate-users-stat-content">
                      <h3 className="duplicate-users-stat-number">
                        {noOfUser}
                      </h3>
                      <p className="duplicate-users-stat-label">
                        Total Duplicates
                      </p>
                    </div>
                  </div>
                  <div className="duplicate-users-stat-card">
                    <div className="duplicate-users-stat-icon unverified-users">
                      <i className="fas fa-exclamation-triangle"></i>
                    </div>
                    <div className="duplicate-users-stat-content">
                      <h3 className="duplicate-users-stat-number">
                        {data.filter((user) => !user?.emailVerified).length}
                      </h3>
                      <p className="duplicate-users-stat-label">
                        Unverified Accounts
                      </p>
                    </div>
                  </div>
                  <div className="duplicate-users-stat-card">
                    <div className="duplicate-users-stat-icon recent-duplicates">
                      <i className="fas fa-calendar-alt"></i>
                    </div>
                    <div className="duplicate-users-stat-content">
                      <h3 className="duplicate-users-stat-number">
                        {
                          data.filter((user) => {
                            const oneWeekAgo = new Date();
                            oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
                            return new Date(user.createdAt) > oneWeekAgo;
                          }).length
                        }
                      </h3>
                      <p className="duplicate-users-stat-label">Last 7 Days</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Table Section */}
              <Table
                data={data}
                setPage={setPage}
                page={page}
                noOfUser={noOfUser}
                limit={limit}
                deleteUser={deleteUser}
                adminType={adminType}
                handleShowEdit={handleShowEdit}
                makeSubscribeUser={makeSubscribeUser}
              />
            </div>
          </div>
        </div>

        <Modal show={showEdit} size="lg" onHide={handleCloseEdit} centered>
          <Modal.Body>
            <div className="duplicate-users-modal">
              <div className="duplicate-users-modal-header">
                <h5 className="duplicate-users-modal-title">Edit User</h5>
                <button
                  className="duplicate-users-modal-close"
                  onClick={handleCloseEdit}
                >
                  <i className="fas fa-times"></i>
                </button>
              </div>
              <div className="duplicate-users-modal-body">
                <EditUserData
                  getUsers={getUsers}
                  setShow={setShowEdit}
                  selectedData={selectedData}
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>

      {loader && <Loader />}
    </>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noOfUser,
  limit,
  deleteUser,
  adminType,
  handleShowEdit,
  makeSubscribeUser,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const checkSubscription = (nextPayment) => {
    let currentDate = new Date();
    let endDate = new Date(nextPayment);

    if (currentDate < endDate) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Joined At
                  </th>
                  <th scope="col" className="">
                    Name
                  </th>
                  <th scope="col" className="">
                    Email
                  </th>
                  <th scope="col" className="">
                    Phone
                  </th>
                  <th scope="col" className="">
                    Wallet
                  </th>
                  <th scope="col" className="">
                    country
                  </th>
                  <th scope="col" className="">
                    DOB
                  </th>
                  <th scope="col" className="">
                    Gender
                  </th>
                  <th scope="col" className="">
                    <div className="w-max-c">Email verified</div>
                  </th>
                  <th scope="col">Action</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </div>
                    </td>
                    <td scope="row" className="d-flex">
                      <div className="table-text-dark w-max-c db">
                        {item?.name}
                      </div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.email}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.phone ? item?.phone : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.wallet ? item?.wallet : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.country ? item?.country : "-"}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.dob}
                      </span>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {item?.gender}
                      </span>
                    </td>
                    <td>
                      {item?.emailVerified ? (
                        <span className="badge bg-success w-max-c db">
                          verified
                        </span>
                      ) : (
                        <span className="badge bg-danger w-max-c db">
                          not verified
                        </span>
                      )}
                    </td>
                    <td>
                      <div className="d-flex ai-center">
                        {adminType == "mackAdmin777" &&
                          (item?.subscription &&
                          item?.subscription.length > 0 ? (
                            <>
                              {checkSubscription(
                                item?.subscription[0]?.nextPayment,
                              ) ? (
                                <button
                                  className="makeSubBtn me-2"
                                  style={{
                                    background: "green",
                                    color: "#fff",
                                    width: 103.6,
                                  }}
                                >
                                  Subscribed
                                </button>
                              ) : (
                                <>
                                  <button
                                    className="makeSubBtn me-2 "
                                    style={{
                                      background: "red",
                                      color: "#fff",
                                      width: 103.6,
                                    }}
                                  >
                                    Expired
                                  </button>
                                  <button
                                    className="makeSubBtn me-2"
                                    onClick={() =>
                                      makeSubscribeUser(item?.email)
                                    }
                                  >
                                    Make Subscribe
                                  </button>
                                </>
                              )}
                            </>
                          ) : (
                            <button
                              className="makeSubBtn me-2"
                              onClick={() => makeSubscribeUser(item?.email)}
                            >
                              Make Subscribe
                            </button>
                          ))}
                        {adminType == "mackAdmin777" && (
                          <a
                            href="#"
                            className="me-2 w-30"
                            onClick={() => handleShowEdit(item)}
                          >
                            <img src={edit} alt="edit" />
                          </a>
                        )}
                        <a
                          href="#"
                          className=" w-30"
                          onClick={() => deleteUser(item?._id)}
                        >
                          <img src={Delete} alt="Delete" />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center mt-4">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfUser / limit)}
                page={page}
                onChange={handleChange}
                color="primary"
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default DuplicateUsers;
